import React, { Component } from "react"
import { Column, CellMeasurerCache } from "react-virtualized"
import PropTypes from "prop-types"
import cloudinary from "cloudinary-core"
import moment from "moment"
import FontAwesome from "react-fontawesome"

import { timeBetween } from "../../helpers/sharedHelperFunctions"
import AssetItemCard from "../AssetItemCard"
import DataTable from "@swipesense/data-table"
import Loading from "../Loading"

import "./LostAssetsTableVirtualized.scss"

class LostAssetsTableVirtualized extends Component {
  constructor(props) {
    super(props)

    this.cache = new CellMeasurerCache({
      minHeight: 160,
      fixedWidth: true,
    })
  }

  assetRenderer = ({ cellData }) => {
    const asset = cellData
    // image-related code
    const cloudinaryCore = new cloudinary.Cloudinary({
      cloud_name: "swipesense-inc",
    })
    const fallbackUrl = "/icons/fallback.svg"
    const photoUrl = asset.imageId
      ? cloudinaryCore.url(asset.imageId, {
          width: 60,
          height: 60,
          crop: "fill",
        })
      : fallbackUrl
    return [
      <div key={asset.id} className="lost-asset-cell">
        <img
          width="60"
          height="60"
          src={photoUrl}
          onError={e => {
            e.target.src = fallbackUrl
          }}
          alt="Asset"
        />
        <div className="lost-asset-info">
          <div className="asset-name">{asset.name}</div>
          <div className="asset-mfg">
            {asset.manufacturer} - {asset.modelName}
          </div>
          <div className="asset-ids">
            <div className="asset-id">
              <div className="id-rectangle">A</div>
              {asset.assetId}
            </div>
            {asset.serialNumber ? (
              <div className="asset-sn">
                <div className="id-rectangle">S</div>
                {asset.serialNumber}
              </div>
            ) : null}
          </div>
        </div>
      </div>,
    ]
  }

  ownershipRenderer = ({ cellData }) => {
    const asset = cellData
    return [
      <div key={asset.id} className="department-owners">
        {asset.owners.map((owner, i) => (
          <div className="owner-name" key={i}>
            {owner.name}
          </div>
        ))}
        {asset.ownership === "rented" ? (
          <div>
            <FontAwesome className="rental-tag" name={"tag"} />
            Rental
          </div>
        ) : null}
      </div>,
    ]
  }

  locationRenderer = ({ cellData }) => {
    const asset = cellData
    return [
      <div key={asset.id} className="lost-location">
        <div>
          <div>{asset.location.unit.name}</div>
          <div>{asset.location.name}</div>
        </div>
      </div>,
    ]
  }

  timeRenderer = ({ cellData }) => {
    const asset = cellData
    const timeSinceDetected = timeBetween(
      Date.parse(asset.lastSeenAt),
      Date.now()
    )
    return [
      <div key={asset.id} className="lost-time">
        {moment.duration(timeSinceDetected).humanize()}
      </div>,
    ]
  }

  render() {
    return (
      <DataTable
        data={this.props.lostAssets}
        rowHeight={90}
        className="LostAssetsTableVirtualized"
        noRowsMessage="Congratulations! You have no lost assets."
        loadingComponent={<Loading />}
      >
        <Column
          width={150}
          dataKey="item"
          disableSort={true}
          headerClassName="table-header"
          label="ASSET"
          cellRenderer={this.assetRenderer}
        />
        <Column
          width={25}
          dataKey="item"
          disableSort={true}
          headerClassName="table-header"
          label="OWNERSHIP"
          cellRenderer={this.ownershipRenderer}
        />
        <Column
          width={25}
          dataKey="item"
          disableSort={true}
          headerClassName="table-header"
          label="LAST LOCATION"
          cellRenderer={this.locationRenderer}
        />
        <Column
          width={25}
          dataKey="item"
          disableSort={true}
          headerClassName="table-header"
          label="TIME LOST"
          cellRenderer={this.timeRenderer}
        />
      </DataTable>
    )
  }
}

LostAssetsTableVirtualized.propTypes = {
  lostAssets: PropTypes.arrayOf(
    PropTypes.shape({ item: PropTypes.shape(AssetItemCard.propTypes) })
  ),
  deviceType: PropTypes.string.isRequired,
}

export default LostAssetsTableVirtualized
